import $ from 'jquery'
const $doc = $(document)

$('.js-tabs').each(function() {
  const $tabsContainer = $(this);
  const $loader = $tabsContainer.find('.js-loader');
  const $wrapper = $tabsContainer.find('.tabs--posts__wrapper');
  
  let current_page = 1;
  let query = null;
  let max_page = 0;
  let current_type = null;
  let current_cat = null;
  
  if ($wrapper.length && $wrapper.data('initial-query')) {
    const initialQueryData = $wrapper.data('initial-query');
    query = typeof initialQueryData === 'string' ? initialQueryData : JSON.stringify(initialQueryData);
    current_page = $wrapper.data('initial-page') || 1;
    max_page = $wrapper.data('initial-max-page') || 0;
  }
  
  const $initialLoadMore = $tabsContainer.find('.js-load-more').first();
  if ($initialLoadMore.length) {
    current_type = $initialLoadMore.data('type');
    current_cat = $initialLoadMore.data('cat');
  }

  function toggleTabItem() {
    const postType = $(this).data('type')
    const postCat = $(this).data('cat')
    const targetContent = $(this).data('target')
    const index = $(this).data('index')
    let el = $(this);

    $tabsContainer.find('.js-tab-item').attr('aria-selected', 'false').attr('tabindex', '-1')
    $tabsContainer.find('.js-tab-content').removeClass('active').attr('hidden', 'true')
    $tabsContainer.find('.js-tab-item span').removeClass('active')

    el.attr('aria-selected', 'true').removeAttr('tabindex')
    el.find('span').addClass('active')
    $(`#${targetContent}`).addClass('active').removeAttr('hidden')

    if(postType) initTabs(postType, postCat, index);
  }

  function loadMore() {
    const $button = $(this);
    const buttonType = $button.data('type');
    const buttonCat = $button.data('cat');
    const typeToUse = buttonType || current_type;
    const catToUse = buttonCat || current_cat;
    
    const data = {
      'action': 'loadmore',
      'query': query,
      'page' : current_page,
      'type': typeToUse,
      'cat': catToUse
    };

    $.ajax({
        url : php_vars.ajax_url,
        data : data,
        type : 'POST',
        beforeSend : function ( xhr ) {
          $tabsContainer.find('.js-load-more').text('Loading...');
        },
        success : function( posts ){
          if( posts ) {
            $tabsContainer.find('.js-load-more').text( 'Load more' );
            $tabsContainer.find('.tabs__posts--list').append( posts );
            current_page++;

            if ( current_page == max_page ) 
              $tabsContainer.find('.js-load-more').hide();

          } else {
            $tabsContainer.find('.js-load-more').hide();
          }
        }
    });
    return false;
  }

  function initTabs(type, cat, index) {
    current_type = type;
    current_cat = cat;
    
    const data = {
      action : "get_tabs",
      type : type,
      cat : cat
    }
    toggleTabs(data, index);
  }

  function toggleTabs(data, index) {
    return $.ajax({
      url : php_vars.ajax_url,
      data : data,
      dataType : 'json',
      beforeSend : function(xhr){
        $tabsContainer.find('.tabs--posts__wrapper').empty();
        $loader.addClass('loading')
        $tabsContainer.find('.js-load-more').hide();
      },
      success : function(response) {
           if( response ) {
            current_page = 1;
            query = response.posts;
            max_page = response.max_page;
            const $wrapper = $tabsContainer.find('.tabs--posts__wrapper');
            $wrapper.removeClass($wrapper.attr('class').split(' ').pop());
            $wrapper.addClass('tabs--'+index);
            $wrapper.html(response.content);
            $loader.removeClass('loading');
            if ( response.max_page < 2 ) {
              $tabsContainer.find('.js-load-more').hide();
            } else {
              $tabsContainer.find('.js-load-more').show();
            }
          }
        }
    });
  }

  var tabIndex = 0;
  var $tabs = $tabsContainer.find('.js-tab-item');

  $tabs.bind(
  {
    keydown: function(ev){
      var LEFT_ARROW = 37;
      var UP_ARROW = 38;
      var RIGHT_ARROW = 39;
      var DOWN_ARROW = 40;

      var k = ev.which || ev.keyCode;

      if (k >= LEFT_ARROW && k <= DOWN_ARROW){

        if (k == LEFT_ARROW || k == UP_ARROW){
          if (tabIndex > 0) {
            tabIndex--;
          }
          else {
            tabIndex = $tabs.length - 1;
          }
        }

        else if (k == RIGHT_ARROW || k == DOWN_ARROW){
          if (tabIndex < ($tabs.length - 1)){
            tabIndex++;
          }
          else {
            tabIndex = 0;
          }
        }

        $($tabs.get(tabIndex)).click();
        ev.preventDefault();
      }
    },

    click: function(ev){
      tabIndex = $.inArray(this, $tabs.get());
      setFocus();
      ev.preventDefault();
    }
  });

  var setFocus = function(){
    $tabs.attr(
    {
      tabindex: '-1',
      'aria-selected': 'false'
    }).removeClass('active');

    $tabsContainer.find('.js-tab-content').removeClass('active').attr('hidden', 'true');

    $($tabs.get(tabIndex)).attr(
    {
      tabindex: '0',
      'aria-selected': 'true'
    }).addClass('active').focus();

    $($($tabs.get(tabIndex)).data('target')).addClass('active').removeAttr('hidden');
  };

  $tabsContainer.on('click', '.js-tab-item', toggleTabItem);
  $tabsContainer.on('click', '.js-load-more', loadMore);
});

$doc.ready( () => {
  const hash = window.location.hash;
  if (hash && hash.includes('+')) { 
    const tab = hash.split('+')[1]
    const button = $(`[data-type="${tab}"]`);
    button.trigger('click');
  }
})
